import React from "react";
import { TextField, Checkbox, FormControlLabel } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import "./suggestion.css";

// Modal style definition for center-aligned modal
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px",
};

const AddSuggestionModal = ({
  open, // modal open flag
  onClose, // close modal handler
  onSave, // function to call on save
  formData, // form data state
  setFormData, // setter for form data
  isEditModel, // edit mode flag
  onEdit, // function to call on edit
}) => {
  // Handle input value change (for text field)
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "name" && value.length > 15) return;

    setFormData({ ...formData, [name]: value });
  };

  // Handle checkbox change (for "Options" flag)
  const handleCheckboxChange = (e) => {
    setFormData({ ...formData, is_option: e.target.checked });
  };

  // Save handler for add mode
  const handleSave = () => {
    if (!formData.name) {
      alert("Please fill all fields!");
      return;
    }
    onSave(formData);
  };

  // Save handler for edit mode
  const handleEdit = () => {
    if (!formData.name) {
      alert("Please fill all fields!");
      return;
    }
    onEdit(formData);
  };

  return (
    <div>
      {/* Modal wrapper */}
      <Modal
        open={open}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            onClose();
          }
        }}
        aria-labelledby="modal-modal-name"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {/* Close icon */}
          <CloseIcon className="closeIcon" onClick={onClose} />

          {/* Modal title */}
          <Typography id="modal-modal-name" variant="h6" component="h2">
            {!isEditModel ? "Add" : "Edit"} Class
          </Typography>

          {/* Input for class name */}
          <TextField
            name="name"
            label="name"
            fullWidth
            margin="dense"
            value={formData.name}
            onChange={handleInputChange}
            inputProps={{ maxLength: 15 }}
            helperText={`${
              15 - (formData.name?.length || 0)
            } characters remaining`}
          />

          {/* Checkbox to mark class as an option */}
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.is_option}
                onChange={handleCheckboxChange}
              />
            }
            label="Options"
          />

          {/* Save button */}
          <div className="suggestionModalSaveButton">
            <Button
              variant="contained"
              onClick={isEditModel ? handleEdit : handleSave}
            >
              SAVE
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default AddSuggestionModal;
